module.exports = __webpack_public_path__ + "img/image-3.8afdcf71.jpg";